import React from 'react';
import { useAuth } from 'api';
import { Loading } from 'ui';
import { Route, Switch, Redirect, useRouteMatch } from 'react-router-dom';
import View from './View';
import Edit from './Edit';
import Plan from './Plan';
import Payment from './Payment';
import InviteUser from './InviteUser';
import RemoveUser from './RemoveUser';
import RemoveInvite from './RemoveInvite';



export default function Company() {
  const {path, url, params:{companyId}} = useRouteMatch();
  const auth = useAuth();
  
  if(!auth) {
    return <Loading/>;
  }
  
  if(auth.user.role !== "ADMIN" && (companyId !== auth.user.companyId || auth.user.role !== "COMPANY_ADMIN")) {
    return <Redirect to="/"/>;
  }
  
  return (
    <Switch>
      <Route path={`${path}/view`} component={View}/>
      <Route path={`${path}/edit`} component={Edit}/>
      <Route path={`${path}/invite-user`} component={InviteUser}/>
      <Route path={`${path}/plan`} component={Plan}/>
      <Route path={`${path}/payment`} component={Payment}/>
      <Route path={`${path}/remove-user/:userId`} component={RemoveUser}/>
      <Route path={`${path}/remove-invite/:inviteId`} component={RemoveInvite}/>
      <Redirect to={`${url}/view`}/>
    </Switch>
  );
}